export const route = {
  home: '/',
  person: '/haushalt/:householdId/analyse/persoenliche-daten/:personId',
  addressEdit: '/haushalt/:householdId/analyse/persoenliche-daten/:personId/adressaenderung',
  personWithActiveForm: '/haushalt/:householdId/analyse/persoenliche-daten/:personId/:activeForm',
  createHousehold: '/haushalt/hinzufuegen',
  manageHousehold: '/haushalt/:householdId/verwalten',
  manageHouseholdWithReturnUrl: '/haushalt/:householdId/verwalten/:returnUrl',
  wishesAndGoals: '/haushalt/:householdId/analyse/wuensche-und-ziele',
  wishesAndGoalsWithSelectedPerson: '/haushalt/:householdId/analyse/wuensche-und-ziele/:personId',
  wishesAndGoalsSalesforce: '/haushalt/:householdId/analyse/wuensche-und-ziele/salesforce',
  wishesAndGoalsSalesforceWithSelectedPerson:
    '/haushalt/:householdId/analyse/wuensche-und-ziele/:personId/salesforce',
  wishesAndGoalsHideFinancialGrade:
    '/haushalt/:householdId/analyse/wuensche-und-ziele/ausgeblendetfinanznote',
  wishesAndGoalsHideFinancialGradeWithSelectedPerson:
    '/haushalt/:householdId/analyse/wuensche-und-ziele/ausgeblendetfinanznote/:personId',
  wishesAndGoalsServiceAnalyse:
    '/haushalt/:householdId/analyse/wuensche-und-ziele/serviceanalyse',
  wishesAndGoalsServiceAnalyseWithSelectedPerson:
    '/haushalt/:householdId/analyse/wuensche-und-ziele/serviceanalyse/:personId',
  savingTypeHome: '/haushalt/:householdId/analyse/ffg/sparer-typ/start',
  savingType: '/haushalt/:householdId/analyse/ffg/sparer-typ/:step',
  kssNameChange: '/haushalt/:householdId/analyse/persoenliche-daten/:kundennummer/namensaenderung',
  kssBankDetailsChange:
    '/haushalt/:householdId/analyse/persoenliche-daten/:kundennummer/bankverbindungsaenderung/:bankverbindungId',
};
